import { type FC, useState } from 'react';
import { type ImageMapArea } from '@/components/attachment-list/attachment-list-types';
import { type OrderInboundsDetailTabsGroupedImagesRoute } from './types';
import { StyleSheet, View } from 'react-native';
import { ZoomableImageMap } from '@/screens/order-inbounds/zoomable-image-map';

interface Props {
  images: OrderInboundsDetailTabsGroupedImagesRoute['images'];
  onAreaSelect: (area: ImageMapArea) => void;
  selectedAreaID?: string;
}

export const OrderInboundsDetailGroupedImagesContent: FC<Props> = ({
  images,
  onAreaSelect,
  selectedAreaID,
}) => {
  const [containerWidth, setContainerWidth] = useState(0);
  const [zoomLevel, setZoomLevel] = useState(1);

  return (
    <View
      onLayout={(e) => setContainerWidth(e.nativeEvent.layout.width)}
      style={styles.container}
    >
      <ZoomableImageMap
        containerWidth={containerWidth}
        images={images.map((image) => ({ areas: image.areas, url: image.url }))}
        onAreaSelect={onAreaSelect}
        selectedAreaID={selectedAreaID}
        setZoomLevel={setZoomLevel}
        zoomLevel={zoomLevel}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
